import i18n from "i18n";

const t = (key, options) => i18n.t(`form:${key}`, options);

// A message for a failing rule the field gave no message for
const defaultMessage = (rule, label) => {
  switch (rule) {
    case "required":
      return label ? t("fieldRequired", { label }) : t("thisFieldRequired");
    case "minLength":
      return label ? t("fieldTooShort", { label }) : t("valueInvalid");
    case "maxLength":
      return label ? t("fieldTooLong", { label }) : t("valueInvalid");
    default:
      return label ? t("fieldInvalid", { label }) : t("valueInvalid");
  }
};

/**
 * Messages of a field's failing rules, shown on its error icon.
 * - errors: failing rules ({ required: true, pattern: true, ... })
 * - errorMsg: the field's own messages ([{ validation, errorMsg }])
 * - label: the field's name, for the default messages ("City is required")
 * - extra: messages for some rules ({ minLength: "..." }) used before the defaults
 * "required" comes first; a rule the field has no message for gets a default one.
 */
export const fieldErrorMessages = ({ errors, errorMsg = [], label = null, extra = {} }) => {
  if (!errors) return [];
  const name = typeof label === "string" && label.trim() ? label.trim() : null;
  const rules = Object.keys(errors).filter((rule) => errors[rule]);
  rules.sort((a, b) => (a === "required" ? -1 : b === "required" ? 1 : 0));
  const messages = [];
  rules.forEach((rule) => {
    const own = errorMsg.filter((el) => el.validation === rule).map((el) => el.errorMsg);
    if (own.length) messages.push(...own);
    else messages.push(extra[rule] ?? defaultMessage(rule, name));
  });
  return [...new Set(messages)];
};
